import { CloseOutlined, LogoutOutlined, MenuOutlined } from '@ant-design/icons';
import * as ROUTE from 'constants/routes';
import { eatsUrl } from 'content/corporateContent';
import logo from 'images/Loggo.png';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { signOut } from 'redux/actions/authActions';

const navItems = [
  { label: 'Home', to: ROUTE.HOME, exact: true },
  { label: 'Services', to: ROUTE.SERVICES },
  { label: 'Smart Stands', to: ROUTE.SMART_STANDS },
  { label: 'Digital Cards', to: ROUTE.DIGITAL_BUSINESS_CARD },
  { label: 'Our Work', to: ROUTE.WORK },
  { label: 'Guides', to: ROUTE.GUIDES },
  { label: 'About', to: ROUTE.ABOUT },
  { label: 'Contact', to: ROUTE.CONTACT }
];

const Navigation = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const isAuthenticating = useSelector((state) => state.app.isAuthenticating);

  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  useEffect(() => {
    document.body.classList.toggle('corporate-menu-open', menuOpen);
    return () => document.body.classList.remove('corporate-menu-open');
  }, [menuOpen]);

  if (pathname.includes('/user/') || pathname.startsWith('/admin/')) return null;

  const accountPath = auth
    ? (auth.role === 'ADMIN' ? ROUTE.ADMIN_DASHBOARD : ROUTE.ACCOUNT_EDIT)
    : ROUTE.SIGNIN;
  const accountLabel = auth
    ? (auth.role === 'ADMIN' ? 'Admin dashboard' : 'My account')
    : 'Client login';

  const preventWhileAuthenticating = (event) => {
    if (isAuthenticating) event.preventDefault();
  };

  const authActions = (mobile = false) => (
    <div className={`corporate-nav-auth${mobile ? ' corporate-nav-auth-mobile' : ''}`}>
      {auth ? (
        <>
          <Link className="corporate-nav-account corporate-nav-account-secondary" onClick={preventWhileAuthenticating} to={accountPath}>
            {accountLabel}
          </Link>
          <button
            className="corporate-nav-account"
            disabled={isAuthenticating}
            onClick={() => dispatch(signOut())}
            type="button"
          >
            <LogoutOutlined aria-hidden="true" />
            {isAuthenticating ? 'Signing out' : 'Sign out'}
          </button>
        </>
      ) : (
        <>
          <Link className="corporate-nav-account corporate-nav-account-secondary" onClick={preventWhileAuthenticating} to={ROUTE.SIGNIN}>
            Sign in
          </Link>
          <Link className="corporate-nav-account" onClick={preventWhileAuthenticating} to={ROUTE.SIGNUP}>
            Sign up
          </Link>
        </>
      )}
    </div>
  );

  return (
    <header className="corporate-navigation">
      <div className="corporate-nav-shell">
        <Link className="corporate-nav-logo" onClick={preventWhileAuthenticating} to="/" aria-label="Takka Smart home">
          <img alt="Takka Smart" src={logo} />
        </Link>

        <nav aria-label="Primary navigation" className={`corporate-nav-links ${menuOpen ? 'is-open' : ''}`} id="corporate-menu">
          <div className="corporate-mobile-menu-header">
            <span>Explore Takka Smart</span>
            <button aria-label="Close navigation menu" onClick={() => setMenuOpen(false)} type="button">
              <CloseOutlined aria-hidden="true" />
            </button>
          </div>
          {navItems.map((item) => (
            <NavLink
              activeClassName="is-active"
              exact={item.exact}
              key={item.label}
              onClick={preventWhileAuthenticating}
              to={item.to}
            >
              {item.label}
            </NavLink>
          ))}
          <a className="corporate-nav-eats" href={eatsUrl} rel="noopener noreferrer" target="_blank">
            Takka Eats
            <span aria-hidden="true">↗</span>
            <span className="sr-only">(opens in a new tab)</span>
          </a>
          {authActions(true)}
        </nav>

        <div className="corporate-nav-actions">
          {authActions()}
          <button
            aria-controls="corporate-menu"
            aria-expanded={menuOpen}
            aria-label="Open navigation menu"
            className="corporate-nav-toggle"
            onClick={() => setMenuOpen(true)}
            type="button"
          >
            <MenuOutlined aria-hidden="true" />
          </button>
        </div>
      </div>
      {menuOpen && <button aria-label="Close navigation menu" className="corporate-nav-backdrop" onClick={() => setMenuOpen(false)} type="button" />}
    </header>
  );
};

export default Navigation;
